/* unplugin-vue-components disabled */import { render } from "./company-originator.vue?vue&type=template&id=2146f484&scoped=true"
const script = {}

import "./company-originator.vue?vue&type=style&index=0&id=2146f484&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2146f484"]])

export default __exports__